/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect, useState } from "react";
import ResultsLayout from "./results-layout";
import CoreLayout from "../../../layouts/core-layout";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import {
  getAllPseudoRequest,
} from "../../../api/PseudoApi";
import { ProductActionHandler } from "../../../lib/product-action-handler/ProductActionHandler";
import { ModalConfirm, PriceDisplay, WarningQuotas } from "../../../lib/product-manager/ProductManager";
import { AttributeGroup, PackageAttribute, Product, ProductAttribute } from "../../../lib/product-manager/types";
import { getPackageOrProduct } from "../../../lib/product-manager/product-manager.service";
import { getProductActions, ProductActionStatus } from "../../../api/ProductManagerActionApi";
import { BankManagerAccounContext } from "../../../lib/bank-manager/BankManagerAccount";
import i18n from "../../../i18n";
import { ProductAttributeGroupManager } from "../../../lib/product-manager/product-attribute-group";

export default function PseudoResults() {
  const { t } = useTranslation(); // Multi Language
  const { diagUUID } = useParams();
  const [refreshCount, setRefreshCount] = useState<number>(0)

  const [allPseudo, setAllPseudo] = useState<any[]>([]);
  const [searchPseudonym, setSearchPseudonym] = useState<string>("")
  const [searchPseudonymErrors, setSearchPseudonymErrors] = useState<string[]>([])

  useEffect(() => {
    if (!searchPseudonym) {
      setSearchPseudonymErrors([
        t("core:pages.osculteo.results.pseudonyms.form.requiredError")
      ])
    } else {
      setSearchPseudonymErrors([])
    }
  }, [searchPseudonym])

  useEffect(() => {
    const fetchData = async () => {
      if (diagUUID) {
        const res = await getAllPseudoRequest(diagUUID);

        setAllPseudo(res.data.data);
      }
    };
    fetchData();
  }, [diagUUID, refreshCount]);

  function getActionMetadata(pseudonym: string) {
    return {
      pseudoType: 'PRO',
      pseudonyme: pseudonym
    }
  }

  const { account, refresh: refreshAccount } = useContext(BankManagerAccounContext)
  const [pendingAction, setPendingAction] = useState<{
    checkoutId: number;
    pendingActionCount: number;
  } | null
  >(null)

  function handleIsActionPending(params: {
    checkoutId: number;
    pendingActionCount: number;
  }) {
    setPendingAction(params)
  }

  const [product, setProduct] = useState<(Product | null)>(null)
  const [selectedOptions, setSelectedOptions] = useState<{ groupId: number, id: number }[]>([])
  const [modalConfirmToggled, setModalConfirmToggled] = useState<boolean>(false)

  useEffect(() => {
    getPackageOrProduct('pseudonyms', 'Product').then((data) => data.results[0])
      .then((product: Product) => {
        setProduct(product)
        setSelectedOptions(
          product.attributeGroups.reduce((array, attributeGroup) => {
            array = [...array, ...attributeGroup.attributes.filter((attribute) => attribute.isDefault).map((attribute) => ({
              ...attribute,
              group: { id: attributeGroup.id } as AttributeGroup<PackageAttribute | ProductAttribute>
            }))]
            return array
          }, [] as ProductAttribute[])
            .map((attribute: ProductAttribute) => ({
              groupId: attribute?.group?.id as unknown as number,
              id: attribute.id as unknown as number
            }))
        )
      }
      )
  }, [refreshCount])

  return (
    <>
      <CoreLayout template="main">
        <ResultsLayout description={""}>
          <div className="row">
            <div className="col-12 col-lg">
              <ProductActionHandler
                pendingActionCount={pendingAction?.pendingActionCount}
                checkoutId={pendingAction?.checkoutId}
                getActions={
                  (checkoutId: number) =>
                    getProductActions({ status: [ProductActionStatus.SUCCESS], checkoutId }).then((response) => {
                      return response.data.data.results
                    })
                }
                onTargetedActionExists={(targetedActions) => {
                  refreshAccount()
                  setPendingAction(null)
                  setRefreshCount((state) => state + 1)
                  setModalConfirmToggled(false)
                }}
              >

                <div className="form w-full shadow-sm p-8">

                  {product?.prices?.[0]?.value ? <div className="mb-10 d-flex align-items-center justify-content-end">
                    <PriceDisplay
                      currentLanguage={i18n.language || 'fr'}
                      value={product?.prices?.[0]?.value || 0}
                      creditSystemEnabled={process.env.REACT_APP_CREDIT_SYSTEM_ENABLED === '1'}
                    />
                  </div> : null}

                  <div className="text-center mb-10">
                    <h1 className="text-dark mb-3">
                      {t("core:pages.osculteo.results.pseudonyms.title")}
                    </h1>
                  </div>
                  <div className="mb-10">
                    {t("core:pages.osculteo.results.pseudonyms.text")}
                  </div>

                  <div className="text-center mb-10">
                    <label
                      className="form-label fw-bolder text-dark fs-6"
                      htmlFor="pseudonyme"
                    >{t(
                      "core:pages.osculteo.results.pseudonyms.form.pseudonymLabel"
                    )}
                    </label>
                    <input
                      className="form-control form-control-lg form-control-solid"
                      type="text"
                      placeholder={t(
                        "core:pages.osculteo.results.pseudonyms.form.pseudonymLabel"
                      )}
                      required
                      id="pseudonyme"
                      onChange={(event) => setSearchPseudonym(event.target.value)}
                    />
                    {searchPseudonymErrors?.length ?
                      <div className="d-flex flex-column gap-2 my-4 text-start">
                        {
                          searchPseudonymErrors?.map((pseudonymError) => <span key={pseudonymError} className="text-danger fs-8 fw-light">{pseudonymError}</span>)
                        }
                      </div>
                      : null}
                  </div>


                  <div className="fv-row mb-10">
                    {product && product.attributeGroups.length ?
                      <ProductAttributeGroupManager
                        currentLanguage={i18n.language || 'fr'}
                        setSelectedOptions={setSelectedOptions}
                        selectedOptions={selectedOptions}
                        groups={product.attributeGroups}
                        creditSystemEnabled={process.env.REACT_APP_CREDIT_SYSTEM_ENABLED === '1'}
                      /> : null

                    }
                  </div>

                  <div className="text-center mt-4">
                    <button
                      className={`btn btn-lg ${!product || !product.isAvailable ? 'btn-secondary' : 'btn-primary'} w-100 mb-5`}
                      disabled={(!product || !product.isAvailable || searchPseudonymErrors?.length) ? true : false}
                      onClick={() => setModalConfirmToggled(true)}
                    >
                      {t(
                        "core:pages.osculteo.results.pseudonyms.action"
                      )}

                    </button>
                  </div>

                  {!product?.isAvailable ? <WarningQuotas products={[product as Product]} currentLanguage={i18n.language || 'fr'} /> : null}

                </div>


                <ModalConfirm
                  diagUUID={diagUUID}
                  // isActionPending={true}
                  creditSystemEnabled={process.env.REACT_APP_CREDIT_SYSTEM_ENABLED === '1'}
                  loadingImageBaneerSrc={`${process.env.REACT_APP_CDN_PLATFORMS}/slider-1.jpg`}
                  currentLanguage={i18n.language as 'fr' | 'en'}
                  userBalance={process.env.REACT_APP_CREDIT_SYSTEM_ENABLED === "1" ? account?.balance || 0 : null}
                  getActionMetadata={() => getActionMetadata(searchPseudonym)}
                  isActionPending={pendingAction ? true : false}
                  setIsActionPending={handleIsActionPending}
                  selectedItems={product && selectedOptions ? [
                    { ...product, selectedProductAttributesIds: selectedOptions.map((selectedOption) => selectedOption.id) }
                  ] : []}
                  setShow={setModalConfirmToggled}
                  show={modalConfirmToggled}
                />

              </ProductActionHandler>

            </div>
            <div className="col-12 col-lg">
              <ResultPseudo allPseudo={allPseudo} />
            </div>
          </div>
        </ResultsLayout>
      </CoreLayout>
    </>
  );
}


const ResultPseudo = (props: any) => {
  const navigate = useNavigate();
  const { t } = useTranslation()
  return (
    <>
      <div className="bg-body rounded shadow-sm p-8">
        <div className="table-responsive m-5">
          <table className="table">
            <thead>
              <tr className="fw-bold fs-6 text-gray-800">
                <th>{t(
                  "core:pages.osculteo.results.pseudonyms.results.table.pseudonymColumn"
                )}</th>
                <th>{t(
                  "core:pages.osculteo.results.pseudonyms.results.table.urlColumn"
                )}</th>
              </tr>
            </thead>
            <tbody>
              {props.allPseudo?.map((pseudo: any) => {
                return (
                  <tr>
                    <td> {pseudo.pseudonyme}</td>
                    <td>
                      <div className="btn btn-sm"
                        onClick={() =>
                          navigate(
                            `/result/${pseudo?.pseudoUuid}/single-pseudo`
                          )
                        }
                      >

                        {t(
                          "core:pages.osculteo.results.pseudonyms.results.table.action"
                        )}

                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};
